// src/hooks/useProductPageContent.js
import { useState } from "react";
import { getProductBySlug, viewProduct } from "../services/productService";

const useProductBySlug = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");
  const [data, setData] = useState();

  const fetchProductBySlug = async (req) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getProductBySlug(req);

      if (response?.status !== "Error") {
        setData(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };


  const callViewProduct = async (id) => {
    setStatus("loading");
    setError("");

    try {
      const response = await viewProduct(id);

      if (response?.status !== "Error") {
        // console.log("fetch category data",response.data)
        setData(response.data ?? response); // depending on API shape
        // setDataOptions(
        //   (response.data ?? response).map((item) => ({
        //     label: item.name,
        //     value: item.id,
        //   }))
        // );
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    fetchProductBySlug,
    callViewProduct,
    data,
    status,
    error,
    resetStatus,
  };
};

export default useProductBySlug;
